import React from 'react'
import foodOne from '../../Images/food/Project Cover.jpg'
import foodTwo from '../../Images/food/Project Cover.png'
import foodThree from '../../Images/food/Project Cover1.jpg'

const Recipies = () => {
    
  return (
    <section className='my-10 px-20'>

            {/* tittle section */}
            <div className=''>
                <h1 className='text-center text-[#676767] text-4xl font-bold'>
                My Recipies
                </h1><br />

                <p className='text-center text-[#252525] font-normal text-lg'>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. <br />
                Lorem Ipsum has been the industry's standard dummy text ever since the <br /> 1500s.
                </p><br />
            </div>

            {/* dynamic card section */}
            <section className='lg:flex lg:justify-around items-center mt-4'>

                <div className='lg:w-[320px] shadow-lg p-3 rounded-2xl'>
                  <img className='w-[320px] h-[220px] border-8 border-white rounded-2xl' src={foodOne} alt="" />

                  <h1 className='text-3xl text-[#18191F] font-bold py-4'>
                  Recipie Title
                  </h1>

                  <p className='text-[#18191F] font-normal text-lg'>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, fermentum amet faucibus sed id nisi lectus at.
                  </p>
                </div>

                <div className='lg:w-[320px] shadow-lg p-3 rounded-2xl'>
                  <img className='w-[320px] h-[220px] border-8 border-white rounded-2xl' src={foodTwo} alt="" />

                  <h1 className='text-3xl text-[#18191F] font-bold py-4'>
                  Recipie Title
                  </h1>

                  <p className='text-[#18191F] font-normal text-lg'>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, fermentum amet faucibus sed id nisi lectus at.
                  </p>
                </div>

                <div className='lg:w-[320px] shadow-lg p-3 rounded-2xl'>
                  <img className='w-[320px] h-[220px] border-8 border-white rounded-2xl' src={foodThree} alt="" />

                  <h1 className='text-3xl text-[#18191F] font-bold py-4'>
                  Recipie Title
                  </h1>

                  <p className='text-[#18191F] font-normal text-lg'>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, fermentum amet faucibus sed id nisi lectus at.
                  </p>
                </div>
                
            </section>
    </section>
  )
}

export default Recipies